import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, ElementRef, ComponentFactoryResolver, Injector, AfterViewInit, AfterContentInit, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { of } from 'rxjs/observable/of';
import { FormBuilder } from '@angular/forms';
import { ExecuteFormsUIState } from './execute-forms.uistate';
import { ExecuteFormsViewModel } from './execute-forms.viewmodel';
import { ExecuteFormsRepository } from './execute-forms.repository';
import { ExecuteFormModel, TerminalType, ActualParameter } from './entities/execute-form.entity';
import { BsModalService } from '@farris/ui-modal';
import { AddExecuteFormComponent } from './add-execute-form/add-execute-form.component';
import { FormConfigContainerComponent } from './form-config-container/form-config-container.component';
import { ParameterSettingComponent } from './parameter-setting/parameter-setting.component';
import { Observable, Subject, forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-execute-forms',
  templateUrl: './execute-forms.component.html',
  styleUrls: ['./execute-forms.component.css'],
  providers: [
    ExecuteFormsUIState, ExecuteFormsViewModel, ExecuteFormsRepository,
    WfLocalePipe,
  ]
})
export class ExecuteFormsComponent implements OnInit, AfterViewInit {
  modalConfig = {
    title: this.localePipe.transform('component.executeForms.executeForms'),
    width: 760,
    height: 532,
    showButtons: true
  };

  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @HostBinding('style.background') style = '#FFF';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(item: ExecuteFormModel) {
    if (item) {
      this.form.Id = item.Id;
      this.form.Name = item.Name;
      this.form.ComponentId = item.ComponentId;
      this.form.formFormatId = item.formFormatId;
      this.form.formatConfigId = item.formatConfigId;
      this.form.FormType = item.FormType;
      this.form.TerminalType = item.TerminalType;
      const paramArray = new Array<ActualParameter>();
      item.ActualParameters.forEach(a => {
        const para = new ActualParameter();
        para.Name = a.Name;
        if(this.designerState.flowFormInfo && this.designerState.flowFormInfo.excuteForms && this.designerState.flowFormInfo.excuteForms.length > 0) {
          if(this.form.formFormatId && this.form.formFormatId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId)){
            if(this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name)) {
              para.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name).name;
            }
          }else if(this.form.ComponentId && this.form.ComponentId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId)) {
            if(this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name)) {
              para.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name).name;
            }
          }
        }
        para.Tag = a.Tag ? a.Tag : this.initVariableType(a.Value);
        para.Value = a.Value;
        paramArray.push(para);
      });
      this.form.ActualParameters = paramArray;
    }
  }
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('configContainer') configContainer: FormConfigContainerComponent;

  @ViewChild('configSection', { read: ElementRef }) configSection: ElementRef<any>;

  form: ExecuteFormModel;

  tab: 'web' | 'mobile' = 'web';

  groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  cols = [];

  location: 'userActivity' | 'process' | 'startActivity';

  showMethodTab = true;

  allParameters = new Array();

  // *******************************************************
  constructor(
    private formBuilder: FormBuilder,
    public uistate: ExecuteFormsUIState,
    public viewmodel: ExecuteFormsViewModel,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private designerState: ProcessDesignerUIState,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.form = new ExecuteFormModel();
    this.allParameters = this.getVariableList();
  }
  ngAfterViewInit(): void {
    if(this.form && this.form.ActualParameters) {
      this.form.ActualParameters.forEach(a => {
        if(this.designerState.flowFormInfo && this.designerState.flowFormInfo.excuteForms && this.designerState.flowFormInfo.excuteForms.length > 0) {
          if(this.form.formFormatId && this.form.formFormatId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId)){
            if(this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name)) {
              a.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name).name;
            }
          }else if(this.form.ComponentId && this.form.ComponentId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId)) {
            if(this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name)) {
              a.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name).name;
            }
          }
        }
      });
      if(this.configContainer && this.configContainer.formFormt) {
        this.configContainer.loaded.subscribe(
          (formFormat)=>{
            if(formFormat && formFormat.id === this.form.formFormatId) {
              this.form.ActualParameters.forEach(para => {
                if(formFormat.urlParameters.find(ac => ac.code === para.Name)) {
                  para.NameDisPlay = formFormat.urlParameters.find(ac => ac.code === para.Name).name;
                }
              })
            }
          }
        ); 
      }
    }
  }

  ngOnInit() {
    this.location = this.editorParams.location;
    this.tab = this.editorParams.tab;
    if (this.location === 'userActivity') {
      this.showMethodTab = true;
    } else {
      this.showMethodTab = false;
    }
  }
  clickOK() {
    let data = new ExecuteFormModel();
    this.getForm().subscribe((re: any) => {
      if (!re.result) {
        return;
      }
      data = re.form;
      if (this.validator(data)) {
        let parameters = null;
        // 如果存在变量类型参数在流程变量上不存在，需要同步流程变量
        if (data && data.ActualParameters && data.ActualParameters.length > 0) {
          const formalParameters = this.designerState.flowFormInfo.formalParameters.filter(p => p.dataType !== 'CDTSchema');
          for (const parameter of data.ActualParameters) {
            if (parameter.Tag ==='variable' && parameter.Value && !this.allParameters.some(p => p.key === parameter.Value) && formalParameters.some(p => p.code === parameter.Value)) {
              parameters = formalParameters;
              break;
            }
          }
        }
        const object = { value: data, parameters };
        this.submitModal.emit(object);
      }
    });
  }

  clickCancel() {
    this.closeModal.emit();
  }

  validator(form: ExecuteFormModel) {
    if (form && form.ActualParameters && form.ActualParameters.length > 0) {
      const formalParameters = this.designerState.flowFormInfo.formalParameters.filter(p => p.dataType !== 'CDTSchema');
      for (const parameter of form.ActualParameters) {
        if (parameter.Tag ==='variable' && parameter.Value && !this.allParameters.some(p => p.key === parameter.Value) && !formalParameters.some(p => p.code === parameter.Value)) {
          this.message.error(this.localePipe.transform('component.executeForms.parameters') + parameter.Name + this.localePipe.transform('component.executeForms.typeAsvariable'));
          return false;
        }
      }
    }
    return true;
  }
  // tabChange(data) {
  //   this.tab = data.nextId;
  // }

  // editCSS() {
  //   this.configSection.nativeElement.querySelector('div.f-section-header').classList.add('mb-0');
  // }

  public getForm(): Observable<any> {
    if (this.form.ComponentId) {
      return of({ result: true, form: this.form });
    } else if (this.form.formFormatId) {
      return this.configContainer.submit().pipe(
        switchMap((re: any) => {
          if (re.result) {
            this.form.formatConfigId = re.configId;
            return of({ result: true, form: this.form });
          } else {
            return of({ result: false, form: this.form });
          }
        })
      );
    } else {
      return of({ result: true, form: null });
    }
  }

  /**
   * 参数设置
   */
  parametersSet() {
    if(!this.form || (!this.form.ComponentId && !this.form.formFormatId)) {
      return;
    }
    const compFactory = this.resolver.resolveComponentFactory(ParameterSettingComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.allParameters = this.allParameters;
    if (this.tab === 'web') {
      if (this.form.ComponentId) {
        compRef.instance.showFormType = true;
        compRef.instance.formType = this.form.FormType;
      }
      compRef.instance.parameters = [...this.form.ActualParameters.map(p => Object.assign({}, p))];
    } else {
      compRef.instance.parameters = [...this.form.ActualParameters.map(p => Object.assign({}, p))];
    }
    compRef.instance.mode = 'bpmn';

    const modalConfig = {
      title: this.localePipe.transform('component.executeForms.parameterSettings'),
      width: 620,
      height: 400,
      showButtons: true,
      buttons: compRef.instance.modalFooter
    };
    const dialog = this.modalService.show(compRef, modalConfig);

    compRef.instance.submit.subscribe(re => {
      if (this.tab === 'web') {
        this.form.ActualParameters = re.parameters;
        this.form.FormType = re.formType;
      } else {
        this.form.ActualParameters = re.parameters;
      }
      dialog.close();
    });
    compRef.instance.cancel.subscribe(re => {
      dialog.close();
    });
  }
  /**
   * 选择表单定义
   */
  selectExecuteForm() {
    const compFactory = this.resolver.resolveComponentFactory(AddExecuteFormComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.tab = this.tab;
    if(this.form){
      compRef.instance.oldComponentId = this.form.ComponentId;
      compRef.instance.oldFormFormatId = this.form.formFormatId;
    }

    const modalConfig = {
      title: this.localePipe.transform('component.executeForms.formDefinitionList'),
      width: 650,
      height: 400,
      showButtons: true,
      buttons: compRef.instance.modalFooter
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.submit.subscribe((re: ExecuteFormModel) => {
      this.form = re;
      if(this.form && this.form.ActualParameters) {
        this.form.ActualParameters.forEach(a => {
          if(this.designerState.flowFormInfo && this.designerState.flowFormInfo.excuteForms && this.designerState.flowFormInfo.excuteForms.length > 0) {
            if(this.form.formFormatId && this.form.formFormatId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId)){
              if(this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name)) {
                a.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.formFormatId === this.form.formFormatId).actualParameters.find(ac => ac.code === a.Name).name;
              }
            }else if(this.form.ComponentId && this.form.ComponentId.length > 0 && this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId)) {
              if(this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name)) {
                a.NameDisPlay = this.designerState.flowFormInfo.excuteForms.find(e => e.appId === this.form.ComponentId).actualParameters.find(ac => ac.code === a.Name).name;
              }
            }
          }
        });
        if(this.configContainer && this.configContainer.formFormt) {
          this.configContainer.loaded.subscribe(
            (formFormat)=>{
              if(formFormat && formFormat.id === this.form.formFormatId) {
                this.form.ActualParameters.forEach(para => {
                  if(formFormat.urlParameters.find(ac => ac.code === para.Name)) {
                    para.NameDisPlay = formFormat.urlParameters.find(ac => ac.code === para.Name).name;
                  }
                })
              }
            }
          ); 
        }
      }
      dialog.close();
    });
    compRef.instance.cancel.subscribe(re => {
      dialog.close();
    });
  }
  clear() {
    this.form = new ExecuteFormModel();
  }

  initVariableType(value): string {
    if (value) {
        if (value.length >= 8 && value.slice(0, 8) === `{"expr":`) {
            return 'expression';
        } else {
            return 'constant';
        }
    } else {
        return 'variable';
    }
  }

  private getVariableList() {
    const context = new Array();
    if (this.designerState.procInstContext.length > 0) {
      for (const variable of this.designerState.procInstContext) {
        context.push(variable);
      }
    }
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerState.formalParameterContext.length > 0) {
      for (const variable of this.designerState.formalParameterContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerState.participantContext.length > 0) {
      for (const variable of this.designerState.participantContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerState.processVariableContext.length > 0) {
      for (const variable of this.designerState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    return context;
  }
}
export class ExecuteFormsConverter implements TypeConverter {
  params: any;
  constructor(
    params: any,
    private localePipe: WfLocalePipe
  ) {
    this.params = params;
  }
  convertTo(data): string {
    if (data) {
      return data.Name;
    } else {
      if (this.params.location === 'process') {
        return this.localePipe.transform('component.executeForms.notSet');
      } else {
        return this.localePipe.transform('component.executeForms.default');
      }
    }
  }
}
